export default __webpack_public_path__ + "static/media/bonus.f5066bbd.svg";